import logger from "../utils/logger";

export async function getNextInvoiceNumber() {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: "CALL get_next_invoice_number();",
                params: [],
            }),
        });

        const data = await response.json();
        console.log(data);

        const invoiceNo = Array.isArray(data) ? (data[0]?.invoice_no || data[0][0]?.invoice_no) : null;
        return invoiceNo;
    } catch (error) {
        logger.error("getNextInvoiceNumber failed", {}, error);
        return null;
    }
}

export async function getInvoiceSequence() {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/api/invoice_sequence");
        const data = await response.json();
        console.log(data);
        return data;
    } catch (error) {
        logger.error("getInvoiceSequence failed", {}, error);
        return [];
    }
}
